import React, {useEffect, useState} from 'react';
import DocumentList from "../../DocumentList/DocumentList";
import useApi from "../../../utils/useApi";
import {useTaxYear} from "../../../contexts/TaxYearContext";


const ClientDocuments = ({user, handleShowHeader, handleShowSettingsHeader}) => {
    const { taxYear, updateTaxYear } = useTaxYear();
    const [loading, setLoading] = useState(true);
    const { getDocuments, getDocumentStatus } = useApi();
    const [documentStatus, setDocumentStatus] = useState(null);
    const [currentDocument, setCurrentDocument] = useState(null);
    const [clientDocuments, setClientDocuments] = useState([]);
    const [availableYears, setAvailableYears] = useState([]);

    useEffect(() => {
        initializeDocumentStatus();
        initializeDocuments();
        handleShowHeader(true);
        handleShowSettingsHeader(false);
    }, []);

    useEffect(() => {
        handleRefresh();
    }, [taxYear]);

    const initializeDocuments = async () => {
        setLoading(true);
        let data = {
            year: taxYear,
        }
        const results = await getDocuments(data);
        setClientDocuments(results.documents);
        setAvailableYears(results.availableYears);
        setLoading(false);
    }

    const initializeDocumentStatus = async () => {
        let data = {
            year: taxYear,
        }
        const response = await getDocumentStatus(user.id, data);
        setDocumentStatus(response);
        setCurrentDocument(response.currentDocument);
    }

    const handleRefresh = () => {
        initializeDocuments();
        initializeDocumentStatus();
    }


    return (
        <>
            <DocumentList documents={clientDocuments} loading={loading} availableYears={availableYears} />
        </>
    );
}


export default ClientDocuments;
